export default "__VITE_ASSET__52c45a27__"